import { Flame } from "lucide-react";

const hexToRgb = (h) => {
  const n = parseInt(h.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
const lerp = (a, b, t) => Math.round(a + (b - a) * t);
export const mixColor = (from, to, t) => {
  const [r1, g1, b1] = hexToRgb(from);
  const [r2, g2, b2] = hexToRgb(to);
  return `rgb(${lerp(r1, r2, t)}, ${lerp(g1, g2, t)}, ${lerp(b1, b2, t)})`;
};

// Dynamic colour for fame: rare (deep indigo) -> famous (electric crimson).
export const fameColor = (v) => mixColor("#312E81", "#E11D48", v / 100);

export const FameSlider = ({ value, setValue }) => {
  const color = fameColor(value);
  return (
    <div className="space-y-4" data-testid="fame-sliders">
      <div className="flex items-center gap-2">
        <span
          className="flex h-8 w-8 items-center justify-center rounded-full text-white transition-colors duration-150"
          style={{ backgroundColor: color }}
        >
          <Flame className="h-4 w-4" />
        </span>
        <h3 className="font-serif text-2xl font-bold text-[#2d2824]">Fame</h3>
      </div>
      <p className="text-sm text-[#6e655b]">
        The heart of Foinn.org. Drag toward <span className="font-bold">Rare</span> for hidden gems
        or <span className="font-bold">Famous</span> for session anthems.
      </p>
      <input
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={(e) => setValue(Number(e.target.value))}
        className="fame-range"
        style={{ "--pct": `${value}%`, "--c": color }}
        data-testid="slider-fame"
      />
      <div className="flex justify-between text-sm font-bold text-[#6e655b]">
        <span>Rare</span>
        <span
          className="rounded-full px-2.5 py-0.5 text-white transition-colors duration-150"
          style={{ backgroundColor: color }}
        >
          {value}
        </span>
        <span>Famous</span>
      </div>
    </div>
  );
};
